import { useMemo } from "react";
import { useAuth } from "hooks/useAuth";
import { useFdeRole } from "hooks/useFdeRole";
import { useGlobalTciManager } from "hooks/useGlobalTciManager";

/**
 * Resolves the helpContent / helpVideos persona key for the signed-in user.
 * fde-t is intentionally excluded (Drift #3).
 */
export function useHelpPersona() {
  const { userData } = useAuth();
  const { primaryRole, loading: fdeLoading } = useFdeRole();
  const { isGlobalTciManager, loading: gtmLoading } = useGlobalTciManager();

  const role = useMemo(() => {
    if (primaryRole === "fde-dc") return "fde-dc";
    if (primaryRole === "fde-c") return "fde-c";
    if (isGlobalTciManager) return "global-tci-manager";

    const accountRole = userData?.role;
    if (accountRole === "regional_admin") return "regional_admin";
    if (accountRole === "admin") return "admin";
    if (accountRole === "facility") return "facility";
    if (accountRole === "professional" || accountRole === "professional-chartmind") {
      return "professional";
    }
    if (accountRole === "patient" || accountRole === "p2" || accountRole === "p4") {
      return "patient";
    }
    return null;
  }, [primaryRole, isGlobalTciManager, userData?.role]);

  return {
    role,
    loading: fdeLoading || gtmLoading,
  };
}
